import { render } from "./ServiceSelect.vue?vue&type=template&id=1b2350d6"
import script from "./ServiceSelect.vue?vue&type=script&lang=js"
export * from "./ServiceSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__